module.exports = __webpack_public_path__ + "static/cot1tv-2dc356a360a295a62cccc05a92e196c1.jpg";